var React = require('react');

function PauseBtnInactiveAr (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"nonzero","fill":"none"},[React.createElement("path",{"d":"M35 67c19.33 0 35-14.998 35-33.5C70 14.998 54.33 0 35 0S0 14.998 0 33.5C0 52.002 15.67 67 35 67z","fillOpacity":".5","fill":"#657C7A","key":0}),React.createElement("rect",{"fillOpacity":".6","fill":"#FFF","x":"23","y":"16","width":"8.4","height":"34","rx":"4.2","key":1}),React.createElement("rect",{"fillOpacity":".6","fill":"#FFF","x":"38.6","y":"16","width":"8.4","height":"34","rx":"4.2","key":2})]));
}

PauseBtnInactiveAr.defaultProps = {"width":"70","height":"67","viewBox":"0 0 70 67"};

module.exports = PauseBtnInactiveAr;

PauseBtnInactiveAr.default = PauseBtnInactiveAr;
